const headers = (method, body) => {
  let header = { Authorization: `Bearer ${localStorage.getItem('token')}` };
  if (body) {
    header['Content-Type'] = 'application/json';
    return {
      method: method,
      headers: header,
      body: JSON.stringify(body),
    };
  } else {
    return {
      method: method,
      headers: header,
    };
  }
};

const syncFindingsService = {
  getFindings: async function (criteria) {
    try {
      let url = `${process.env.REACT_APP_API_URL}/sync-findings/staff/fetch`;
      const response = await fetch(url, headers('POST', criteria));
      if (response.ok) {
        return await response.json();
      } else {
        return { findings: [], totalCount: 0 };
      }
    } catch (error) {
      console.error(error);
      return { findings: [], totalCount: 0 };
    }
  },

  getCounts: async function () {
    try {
      let url = `${process.env.REACT_APP_API_URL}/sync-findings/staff/counts`;
      const response = await fetch(url, headers('GET'));
      if (response.ok) {
        return await response.json();
      } else {
        return { needsReview: 0, errors: 0, autoCorrectedLast24h: 0, ignored: 0 };
      }
    } catch (error) {
      console.error(error);
      return { needsReview: 0, errors: 0, autoCorrectedLast24h: 0, ignored: 0 };
    }
  },

  getFinding: async function (id) {
    try {
      let url = `${process.env.REACT_APP_API_URL}/sync-findings/staff/${id}`;
      const response = await fetch(url, headers('GET'));
      if (response.ok) {
        return await response.json();
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  updateStatus: async function (id, payload) {
    try {
      let url = `${process.env.REACT_APP_API_URL}/sync-findings/staff/${id}/status`;
      const response = await fetch(url, headers('POST', payload));
      if (response.ok) {
        return await response.json();
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  endSubscription: async function (id, payload) {
    try {
      let url = `${process.env.REACT_APP_API_URL}/sync-findings/staff/${id}/end-subscription`;
      const response = await fetch(url, headers('POST', payload));
      if (response.ok) {
        return { ok: true, finding: await response.json() };
      } else {
        const body = await response.json().catch(() => ({}));
        return { ok: false, error: body.error || 'Failed to end subscription.' };
      }
    } catch (error) {
      console.error(error);
      return { ok: false, error: 'Failed to end subscription.' };
    }
  },
};

export default syncFindingsService;
